import AddIcon from '@mui/icons-material/Add';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { EmptyState } from '../../../components/empty-state';
import { MODULE_ACCENT_COLORS } from '../../../theme/module-colors';

const accent = MODULE_ACCENT_COLORS.goodsReceiving.main;

interface ItemsEmptyStateProps {
  onAddClick: () => void;
}

export function ItemsEmptyState({ onAddClick }: ItemsEmptyStateProps) {
  const { t } = useTranslation('goodsReceiving');

  return (
    <EmptyState
      icon={<Inventory2OutlinedIcon />}
      accentColor={accent}
      title={t('itemsEmptyTitle')}
      description={t('itemsEmptyDesc')}
      iconAriaHidden
      examples={{
        title: t('itemsEmptyExamplesTitle'),
        items: [t('itemsEmptyExample1'), t('itemsEmptyExample2'), t('itemsEmptyExample3')],
      }}
      action={
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onAddClick}
          size="large"
          sx={{ minHeight: 56, minWidth: 240 }}
        >
          {t('addItem')}
        </Button>
      }
    />
  );
}
